// extracted by mini-css-extract-plugin
export default {"content":"PayerDataDetailsModalContent_content__yNPwF"};